import ParticipantService from "@/services/ParticipantService";

export default {
  namespaced: true,
  state: {
    userList: null,
    userListByAdmin: null
  },
  mutations: {
    saveUserList (state, userList) {
      state.userList = userList.participants.map(user => {
        const newUser = { ...user }
        for (const key of Object.keys(newUser)) {
          newUser[key] = newUser[key][0]
        }
        return newUser;
      });
    },
    updateUserStatus (state, newUser) {
      state.userList = [newUser, ...state.userList.filter(user => user.name !== newUser.name)]
    },
    deleteUser (state, username) {
      if (state.userList) {
        state.userList = [...state.userList.filter(user => user.name !== username)]
      }
    },
    resetUserList(state) {
      state.userList = null
    },
    deleteMultiUser (state, participants) {
      if (state.userList) {
        state.userList = [...state.userList.filter(user => {
          return participants.every(party => {
            return party.name !== user.name
          })
        })]
      }
    },
    saveUserListByAdmin (state, userList) {
      state.userListByAdmin = userList&&userList.participants&&userList.participants.map(user => {
        const newUser = { ...user }
        for (const key of Object.keys(newUser)) {
          newUser[key] = newUser[key][0]
        }
        return newUser;
      })||[];
    },
  },
  actions: {
    async getParticipants ({ commit, rootState, state }, entityTag) {
      const token = rootState.auth.token
      try {
        const res = await ParticipantService.getParticipants({ lastName: entityTag }, token)
        commit('saveUserList', res.data)
        return state.userList;
      } catch (err) {
        throw new Error(err)
      }
    },
    disableParticipant ({ commit, rootState, state }, user) {
      const token = rootState.auth.token
      return ParticipantService.disableParticipant({ user: user }, token).then(() => {
        commit('updateUserStatus', user)
        return state.userList;
      }).catch((err) => {
        throw new Error(err)
      })
    },
    deleteParticipant ({ commit, rootState }, params) {
      const token = rootState.auth.token
      return ParticipantService.deleteParticipant(params, token).then((res) => {
        if (res.data.status) {
          commit('deleteUser', params.name)
        }
        return res;
      }).catch((err) => {
        throw new Error(err)
      })
    },
    changePassword ({ rootState }, user) {
      const token = rootState.auth.token
      return ParticipantService.changePass({ user: user }, token).then(res => {
        return res;
      }).catch((err) => {
        throw new Error(err)
      })
    },
    deleteMultiParticipants({commit, rootState}, params) {
      const token = rootState.auth.token
      return ParticipantService.deleteMultiParticipants(params, token).then((res) => {
        if (res.data.status) {
          commit('deleteMultiUser', params.participants)
        }
        return res;
      }).catch((err) => {
        throw new Error(err)
      })
    },
    async getParticipantsByAdmin ({ commit, rootState, state }) {
      const token = rootState.auth.token
      const owner = rootState.auth.username
      try {
        const res = await ParticipantService.getParticipantsByAdmin({ owner }, token)
        commit('saveUserListByAdmin', res.data)
        return state.userListByAdmin;
      } catch (err) {
        throw new Error(err)
      }
    },
    async searchParties ({ commit, rootState }, params) {
      const token = rootState.auth.token
      const lastName = rootState.auth.entityTag
      const searchName = params
      try {
        const res = await ParticipantService.searchParticipants({ lastName, searchName }, token)
        commit('saveUserList', res.data)
        return res;
      } catch (err) {
        throw new Error(err)
      }
    },
  }
}